import { Injectable } from '@angular/core';

export const FD_CONSTRAINTS = {
  principal:   { min: 1_000, max: 100_000_000, step: 1_000 },
  rate:        { min: 3,     max: 12,          step: 0.1   },
  tenureYears: { min: 0.25,  max: 10,          step: 0.25  }
} as const;

export interface FdQuarterRow {
  quarter: number;
  year: number;
  balance: number;
}

export interface FdResult {
  quarters: FdQuarterRow[];
  principal: number;
  totalInterest: number;
  maturityValue: number;
}

@Injectable({ providedIn: 'root' })
export class FdCalculatorService {

  /** Standard Indian bank FD: interest compounded quarterly. */
  calculate(principal: number, annualRate: number, tenureYears: number): FdResult {
    const r = annualRate / 100 / 4;
    const totalQuarters = Math.round(tenureYears * 4);

    const quarters: FdQuarterRow[] = [];
    for (let q = 1; q <= totalQuarters; q++) {
      quarters.push({ quarter: q, year: Math.ceil(q / 4), balance: principal * Math.pow(1 + r, q) });
    }

    const maturityValue = quarters.length ? quarters[quarters.length - 1].balance : principal;

    return { quarters, principal, totalInterest: maturityValue - principal, maturityValue };
  }
}
